import { createGlobalStyle } from "styled-components";

import { normalize } from "polished";
import { blue, textColor } from "./colors";

export const GlobalStyle = createGlobalStyle`
 ${normalize()}
 
 html {
     font-size: 16px;
     box-sizing: border-box;
 }

 *, *:before, *:after {
     box-sizing: inherit;
 }

 body {
     margin:0;
     font-family: 'Montserrat'  ,sans-serif;
    
 
 }

 /* .title-small {
      font-size: 1.2rem;
      
      color: ${blue[100]};
    }

 .title {
      font-size: 1.7rem;
      text-transform: uppercase;
      color: ${blue[100]};
    }
    .copy {
      line-height: 1.54rem;
      color: ${textColor[100]};
      font-family: 'Lato', sans-serif;
    } */

`;
